import { ICommerceOrder } from '~/types/ICommerceOrder';
import { get } from '../cookie';
import { siteAxios } from './client';

type AllArguments = {
  secretKey?: string;
  pagination?: {
    page?: number;
    perPage?: number;
  };
};

export const meOrders = {
  all: async ({ secretKey, pagination }: AllArguments) => {
    const config = {
      headers: {
        'X-Session-Key': secretKey || get('secretKey')
      },
      params: pagination || {}
    };

    const response = await siteAxios.get<ICommerceOrder[]>(
      `/api/v2/mw/users/me/orders`,
      config
    );

    return response.data;
  }
};
